/**
 * If hitting a target will result in a negative pnl, we dont try to take profit at the target. An example of this 
 * is with candle magnitude, that if when the magnitude hits, we won't take profits at that level.
 *{
	"messageType": "alertNotification",
	"notificationId": 1645460769757,
	"notificationDetails": {"warningType":"TRADE_PLAN_WARNING","notificationType":"WARNING","TRADE_PLAN":{"type":"BASIC_TRADING_SYSTEM","id":1,"symbol":"XYZ"}},
	"status": "TARGET_HIT_BUT_NEGATIVE_PNL",
	"statusDetails": {"tacticName":"CANDLE_MAGNITUDE","target":101.0,"currentPnl":-24.4},
	"date": "2022-02-21T11:26:10.681-0500",
	"timestamp": "1645460770682"
}


 * @param {*} statusDetails 
 * @returns object containing following fields...
 * 1) tacticName: name of the tactic that this message applies to.
 * 
 * 2) target: the target that the user desired to take profit at.
 * 
 * 3) currentPnl: the current pnl which makes us filter out the take profit target
 * 
 */
export function targetHitButNegativePnlParser(statusDetails) {
  const parsedObj = {
    tacticName: null,
    target: null,
    currentPnl: null,
  };
  if (statusDetails) {
    parsedObj.tacticName = statusDetails.tacticName ?? null;
    parsedObj.target = statusDetails.target ?? null;
    parsedObj.currentPnl = statusDetails.currentPnl ?? null;
  }

  return parsedObj;
}
